import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'wdx-switch',
    templateUrl: './wdx-switch.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxSwitchComponent implements OnInit {
    @Input() toggled?: boolean;
    @Input() disabled?: boolean;
    @Input() label?: string;

    @Output() toggledChanged: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    instanceId?: string;

    ngOnInit() {
        this.instanceId = uuidv4();
    }

    toggleCheck() {
        this.toggledChanged.emit(this.toggled);
    }

    toggleSwitch() {
        this.toggled = !this.toggled;
        this.toggledChanged.emit(this.toggled);
    }
}
